import { CollapsibleTags } from "./CollapsibleTags.component";

export { CollapsibleTags };
